var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum, IsString } from "class-validator";
export var NotificationAttachmentType;
(function (NotificationAttachmentType) {
    NotificationAttachmentType["URL"] = "URL";
    NotificationAttachmentType["BASE64"] = "BASE64";
})(NotificationAttachmentType || (NotificationAttachmentType = {}));
export class NotificationAttachment {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(NotificationAttachmentType),
    __metadata("design:type", String)
], NotificationAttachment.prototype, "contentType", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], NotificationAttachment.prototype, "content", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], NotificationAttachment.prototype, "filename", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], NotificationAttachment.prototype, "type", void 0);
export class LanguageSwitchUrls {
}
export class PatientLanguageSwitchUrls {
}
